export var Ordering;
(function (Ordering) {
    Ordering["OLDEST_FIRST"] = "OLDEST_FIRST";
    Ordering["NEWEST_FIRST"] = "NEWEST_FIRST";
    Ordering["MOST_REACTIONS_FIRST"] = "REACTION_COUNT";
    Ordering["MOST_VOTES_FIRST"] = "NET_VOTE_COUNT";
    Ordering["LEAST_VOTES_FIRST"] = "NET_VOTE_COUNT_ASC";
    Ordering["HIGHEST_RATED_FIRST"] = "RATING";
    Ordering["LOWEST_RATED_FIRST"] = "RATING_ASC";
})(Ordering || (Ordering = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var MentionType;
(function (MentionType) {
    MentionType["GROUP"] = "GROUP";
})(MentionType || (MentionType = {}));
//# sourceMappingURL=common-enums.js.map